<template>
    <div class="modal-container">
        <div class="modal-wrapper">
            <slot />
        </div>
        <div @click="$emit('close')" class="modal-shade" />
    </div>

</template>

<script>

export default {
//可接受几何属性控制大小

}
</script>>

<style lang="stylus" scoped>
.modal-container
    position: fixed
    left: 0
    top: 0
    right: 0
    bottom: 0
    outline: 0
    z-index: 1000
.modal-wrapper
    position: absolute
    top: 40%
    left: 50%
    transform: translate(-50%, -50%)
    background-color: #FFFFFF
    z-index: 11
    padding: 16px 24px
    border-radius: 10px
    box-shadow: 0 0 2px #ccc
.modal-shade
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    background rgba(0, 0, 0, .6)
</style>>